/**
 * CheckIcon — issue #438 visual system. Single icon in the brand
 * palette (currentColor stroke, 2px line, rounded caps). Tree-shakable
 * via direct import path:
 *
 *   import { CheckIcon } from './icons/CheckIcon';
 *
 * Accepts `size` (default 20) and `className`. Omit `aria-label` to
 * mark the icon as decorative (`aria-hidden="true"` by default); supply
 * `aria-label` to render as a labelled image with `role="img"`.
 */
import type { ReactElement } from 'react';
import type { IconProps } from './iconTypes';
import { SHARED_ICON_ATTRS } from './iconTypes';

export function CheckIcon({ size = 20, className, ...rest }: IconProps): ReactElement {
  const aria = rest['aria-label']
    ? { role: 'img' as const, 'aria-label': rest['aria-label'] }
    : { 'aria-hidden': true };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...SHARED_ICON_ATTRS}
      {...aria}
      {...className ? { className } : undefined}
      {...rest}
    >
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}
